import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import ProfileAvatar from '../profileAvatar'
import theme from '../../constants/theme'
import {
  SideCard,
  ProfileCardHeader,
  CompanyLogoImg,
  CompanyDivider,
  DetailRowsList,
  DetailRow,
  DetailLabel,
  DetailValueLink,
  RequirementsIconCircle,
  BlockTypography,
  Typography,
} from '../styled'
import GeoAlt from '../../assets/svgs/GeoAlt'
import Globe2 from '../../assets/svgs/Globe2'
import Briefcase from '../../assets/svgs/Briefcase'
import PeopleFill from '../../assets/svgs/PeopleFill'

function CompanyDetails({
  location,
  size,
  website,
  industry,
  logo,
  companyName,
}) {
  const { t } = useTranslation()

  const details = [
    {
      icon: <GeoAlt width="14" height="14" color={theme.brandColorOrange} />,
      label: t('general.location'),
      value: location,
    },
    {
      icon: (
        <PeopleFill width="14" height="14" color={theme.brandColorOrange} />
      ),
      label: t('card.companySize'),
      value: size,
    },
    {
      icon: <Globe2 width="14" height="14" color={theme.brandColorOrange} />,
      label: t('general.website'),
      value: website,
      isLink: true,
    },
    {
      icon: <Briefcase width="14" height="14" color={theme.brandColorOrange} />,
      label: t('card.industry'),
      value: industry,
    },
  ].filter((d) => d.value)

  return (
    <SideCard>
      <ProfileCardHeader>
        {logo ? (
          <CompanyLogoImg src={logo} alt="logo" />
        ) : (
          <ProfileAvatar name={companyName} size={3} />
        )}
        <div>
          <BlockTypography bold size="15px" color={theme.brandColorOrange}>
            {companyName}
          </BlockTypography>
        </div>
      </ProfileCardHeader>

      <CompanyDivider />

      <DetailRowsList>
        {details.map((detail, i, arr) => (
          <DetailRow key={detail.i} isLast={i === arr.length - 1}>
            <RequirementsIconCircle>{detail.icon}</RequirementsIconCircle>
            <DetailLabel>{detail.label}</DetailLabel>
            {detail.isLink ? (
              <DetailValueLink
                href={detail.value}
                target="_blank"
                color={theme.brandColorOrange}
              >
                {detail.value}
              </DetailValueLink>
            ) : (
              <Typography size="13px" bold color={theme.talentinoBlack}>
                {detail.value}
              </Typography>
            )}
          </DetailRow>
        ))}
      </DetailRowsList>
    </SideCard>
  )
}

CompanyDetails.propTypes = {
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.string,
  website: PropTypes.string,
  industry: PropTypes.string,
  logo: PropTypes.string,
  companyName: PropTypes.string,
}

export default CompanyDetails
